export default {"src":"/_next/static/media/discover.4fab8868.svg","height":24,"width":34,"blurWidth":0,"blurHeight":0};